<template lang="pug">
.loading(v-if="twinLoadingState.loading")
  el-skeleton(:rows="4", animated) 
el-alert(
  v-else-if="!twinLoadingState.loading && twinLoadingState.error",
  type="error",
  :closable="false"
) {{ $t("genericError") }}
TicketView(
  v-if="ticket",
  :ticket="ticket",
  :useAuth="useProcessMiningTicketAuth",
  :ticket-template-query="{ type: dataQualityTicketType }",
  :preview="props.preview",
  ticketHistoryViewName="pmDataQualityTicketHistory",
  hide-sops
)
  template(#additionalHeaderFields)
    .tm-item
      .smx-label {{ $t("table") }}
      //- TODO: add link
      router-link(
        v-if="tableId && tableLoadState.result?.[0]?.databaseId",
        :to="{ name: 'pmDataQualityTableDetails', params: { tableId: tableId, databaseId: tableLoadState.result?.[0]?.databaseId } }"
      )
        span {{ tableLoadState.result?.[0]?.name || "-" }}
      span(v-else, v-loading="tableLoadState.loading") {{ "-" }}
</template>

<script setup lang="ts">
import TicketView from "@shared/components/tickets/TicketView.vue";
import { computed, onBeforeMount, onMounted, ref, watch } from "vue";
import { useTwinStore } from "@shared/stores/twinManagement";
import { useProcessMiningTicketAuth } from "../hooks/processMiningAuth";
import { stateInitial } from "@shared/models/state";
import { loadPaginatedResource } from "@shared/util/loadResource";
import { searchTables } from "@shared/services/processMining";
import { type BreadCrumb, useMenuStore } from "@shared/stores/menu";
import { type TwinResponse } from "@shared/services/twinManagement";
import { dataQualityTicketType } from "../constants";

const props = defineProps<{
  id?: string;
  ticket?: TwinResponse;
  preview?: boolean;
}>();

const emits = defineEmits<{
  (e: "ticketLoadState", state: LoadState): void;
  (e: "tableLoadState", state: LoadState): void;
}>();

const twinStore = useTwinStore();

watch(
  () => props.id,
  () => {
    if (props.id) {
      void twinStore.loadTwin(props.id);
    }
  },
);

const twinLoadingState = computed(() => twinStore.twinLoadingState);

watch(
  twinLoadingState,
  (newState) => {
    emits("ticketLoadState", newState);
  },
  { immediate: true },
);

const ticket = computed(() => props.ticket || twinLoadingState.value.result);

onBeforeMount(() => {
  if (props.id) {
    void twinStore.loadTwin(props.id);
  }
});

// Load the according table for breadcrumbs and the table relation in the ticket
const tableId = computed(() => {
  return ticket.value?.properties?.find((item) => item.customId === "tableId")
    ?.propertyValue?.value as string;
});

const tableLoadState = ref({ ...stateInitial });

watch(tableLoadState, (newState) => {
  emits("tableLoadState", newState);
});

watch(
  tableId,
  (newTableId) => {
    if (newTableId) {
      void loadPaginatedResource(
        () => searchTables({ page: 1, pageSize: 1, tableId: newTableId }),
        tableLoadState,
      );
    }
  },
  { immediate: true },
);
</script>
